import makeCrudModule from "./crud";
import creditTransferService from "../../services/credittransfer";
import SubmissionError from "../../error/SubmissionError";

const handleError = (commit, e) => {
  commit('TOGGLE_LOADING');

  if (e instanceof SubmissionError) {
    commit('SET_VIOLATIONS', e.errors);
    // eslint-disable-next-line
    commit('SET_ERROR', e.errors._error);

    return;
  }

  // eslint-disable-next-line
  commit('SET_ERROR', e.message);
};

const module = makeCrudModule({
  service: creditTransferService
});

module.actions.fetchRelatedTransfers = ({ commit }, id) => {

  commit('SET_ERROR', '');
  commit('TOGGLE_LOADING');

  return creditTransferService.findInCreditTransferPaymentRun(id)
    .then(response => response.json())
    .then(retrieved => {
      commit('TOGGLE_LOADING');
      commit(
        'SET_TOTAL_ITEMS',
        retrieved['hydra:totalItems']
      );
      commit('SET_VIEW', retrieved['hydra:view']);

      if (true === module.state.resetList) {
        commit('RESET_LIST');
      }

      retrieved['hydra:member'].forEach(item => {
        commit('ADD', item);
      });
    })
    .catch(e => handleError(commit, e));
};

export default module;
